import React, { useContext, useEffect, useState, useRef } from 'react';
import CourseTheatreRecipe from "../../flows/CourseTheatreRecipe";
import { useTranslation } from 'react-i18next';
import {useMutation} from 'react-apollo';
import gql from 'graphql-tag';
import TopNavbar from 'components/TopNavbar/TopNavbar';
import Loading from '../../components/Loading/Loading';
import LessonListItem from 'components/LessonListItem/LessonListItem';
import LessonVideoItem from 'components/LessonVideoItem/LessonVideoItem';
import UserContext from "../../pages/Login/UserContext";
import {updateUserProgress} from '../../graphql/mutations';
import { isUserSubscribed } from '../../utils/subscriptionUtils';
import { GlobalContext } from "context/GlobalContext";
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import FullscreenTakeover from 'components/FullscreenTakeover/FullscreenTakeover';
import LessonFeedback from 'pages/Lesson/LessonFeedback';
import {updateUser1stFeedbackComplete} from '../../graphql/mutations';
import ScrollBar from 'components/ScrollBar/ScrollBar';
import getLessonRequirementsArr from 'utils/getLessonRequirementsArr';
import TodoPopup from 'components/Popups/TodoPopup/TodoPopup';

import './Lessons.scss';
import {
  getProgressAsArr,
} from "utils/courseFunctions"
import { buildRecipeIndex, isNodeCompleted } from '../../utils/buildRecipeIndex';

const theatreIdx = buildRecipeIndex(CourseTheatreRecipe);

function deriveProgressArrFromProgressById(progressById) {
  let lessonsProgress = theatreIdx.lessonIds.length;
  for (let i = 0; i < theatreIdx.lessonIds.length; i++) {
    if (!isNodeCompleted(theatreIdx, theatreIdx.lessonIds[i], progressById)) {
      lessonsProgress = i;
      break;
    }
  }
  const coursesProgress = isNodeCompleted(theatreIdx, theatreIdx.courseIds[0], progressById) ? 1 : 0;
  return [coursesProgress, lessonsProgress, 0, 0];
}

function Lessons({user, authContext}) {
  
  const [CHEATS, setCHEATS] = useState(false)
  const [CHEATSprogress, setCHEATSprogress] = useState(user.userProgress)
  // Let i18n manage body lang/dir
  const PageRef = useRef(null);
  const [ShowTodo, setShowTodo] = useState(false)
  const [TodoPopupLessonNumber, setTodoPopupLessonNumber] = useState(1)

  const openLessonTodoPopup = (lessonNumber) => {
    setTodoPopupLessonNumber(lessonNumber)
    setShowTodo(true)
  }

  function closeTodoPopup () {
    setShowTodo(false)
  }

  

  const userID = user.id;
  const {t} = useTranslation();

  const thisCourseNumber = 0;
  const LessonsRecipe = CourseTheatreRecipe.lessons;

  const [isLoading, setIsLoading] = useState(true);
  const [UserProgress, setUserProgress] = useState([0, 0, 0, 0]);

  useEffect(() => {
    const fetchUserProgress = async () => {
      if (user) {
        const up = user.userProgress;
        let initialProgress;
        if (up?.progressById) {
          // New engine format: { progressById, activeStepItemId }
          initialProgress = deriveProgressArrFromProgressById(up.progressById);
        } else {
          initialProgress = up ? await getProgressAsArr(up) : [0, 0, 0, 0];
        }
        setUserProgress(initialProgress);
      }
      setIsLoading(false);
    };

    fetchUserProgress();
  }, [user, user?.userProgress]);

  const {VolumeSwitchState, setVolumeSwitchState, setIsPWallOpen} = useContext(GlobalContext);

  const [pageBackgroundColor, setPageBackgroundColor] = useState("var(--color-skyblue)");

let [coursesProgress, lessonsProgress, stepsProgress, stepItemsProgress] = (UserProgress || [0,0,0,0])

const hasSeenPaywall = !!user?.userLog?.log?.some?.(e => e?.eventName === 'PAYWALL_OPENED')

  // Array.isArray(user.userProgress) && user.userProgress.length > 0
  //     ? user.userProgress
  //     : {};
const [ShouldCelebrateLessonCompleted, setShouldCelebrateLessonCompleted] = useState(false);

  const getLessonState = (lessonIndex, lockedIfNotSubscribed) => {

    //check if entire course is completed
    if(coursesProgress <= thisCourseNumber){
      //check lesson state
      if (lessonsProgress == lessonIndex) {
        // if(!isUserSubscribed(user) && lockedIfNotSubscribed) return 'locked'
        return 'current';
      } else if (lessonsProgress > lessonIndex) {
        return 'completed';
      } else {
        return 'disabled';
      }
    } else {
      return 'completed';
    }
};

const [is1stFeedbackON, setIs1stFeedbackON ] = useState(false)


useEffect(() => {
  if(!authContext.user.is1stFeedbackComplete && (lessonsProgress === 2)){
    setIs1stFeedbackON(true)
  }
  // refetch();
  // console.log("authContext.user.isSubscribed? ", isUserSubscribed(authContext.user))

}, [authContext.user.id, lessonsProgress])

document.documentElement.style.setProperty("--page-background-color",pageBackgroundColor);

const { handleUserUpdate } = useContext(UserContext);

const [updateUser, { data, loading, error }] = useMutation(gql(updateUserProgress), {
  update(cache, { data: { setUserProgress } }) {
    if (!setUserProgress) {
      console.error('setUserProgress is undefined or null');
      return;
    }
    handleUserUpdate(setUserProgress);
  },
});

const UpdateUserProgressFunc = async (someProgress) => {
  try {
    await updateUser({ variables: { userProgress: someProgress } });
  } catch (error) {
    console.error('Error updating user progress:', error);
  }
};

const [videoPlayer, setVideoPlayer] = useState(false)
const [LessonVideoItemURL, setLessonVideoItemURL] = useState("")

const onExit = () => {
  setVideoPlayer(false)
}
const onOpenVideo = () => {
  setVideoPlayer(true)
}

const [updateUser1stFeedbackCompleteMutation] = useMutation(gql(updateUser1stFeedbackComplete), {
  update(cache, {data: {setUserIs1stFeedbackComplete}}) {
    handleUserUpdate(setUserIs1stFeedbackComplete);
  }
});


const finishFeedback = () => {
  updateUser1stFeedbackCompleteMutation({
    variables: {
      is1stFeedbackComplete: true
    }
  })

  setIs1stFeedbackON(false)
}

  return (
    <>
      {CHEATS ? 
        <>
        <div>
        </div>
        </>
      : ""
      }
      {is1stFeedbackON && 
        <FullscreenTakeover 
          children ={
            <LessonFeedback 
              onFinish={finishFeedback}
            />
          }
        />
      }
      {ShowTodo &&
        <TodoPopup
          closeTodoPopup={closeTodoPopup}
          pathname={LessonsRecipe[TodoPopupLessonNumber].pathname}
          title={t(LessonsRecipe[TodoPopupLessonNumber].name)}
          lessonRequirements={getLessonRequirementsArr(LessonsRecipe[TodoPopupLessonNumber].steps)}
          userHasEmail={user.email ? user.email : null}
          state={getLessonState(TodoPopupLessonNumber, LessonsRecipe[TodoPopupLessonNumber].lockedIfNotSubscribed)}
        />
      }

      {videoPlayer && 
          <div className="lessonLobby-container--video">
            <VideoPlayer
              URL={LessonVideoItemURL}
              onExit={onExit}
              onContinue={onExit}
              IsCurrentSelectedStepItemCompleted={true}
              volume={VolumeSwitchState}
              VideoPlayerLoop={false}
            />
        </div>
      }
      {!videoPlayer &&
      <>
      <TopNavbar
        showNavBG={true}
        showLogo={false}
        authContext={authContext}
        user={user}
        title={t(`course.theatre.courseName`)}
        // BackLinkTo={'/'}
        backgroundColor={pageBackgroundColor}
        border={true}
        opacity={'0.93'}
        texture={true}
        showMenuButton
        showLangButton
        VolumeSwitchState = {VolumeSwitchState} 
        setVolumeSwitchState = {setVolumeSwitchState}
        // showFeedbackModalButton
        // openFeedbackPopup={openFeedbackPopup}
      ></TopNavbar>
        {isLoading && <Loading />}
          <ScrollBar scrollContainerRef={PageRef} hideOnMobile/>
          <div ref={PageRef} className="course--container  course--container__theatre noselect texture">
              <div className="Lessons__list ">
                {LessonsRecipe.map((lessonRecipe, index) => (
                  <React.Fragment key={index}>
                    {lessonRecipe.type === "LessonListItem" && (
                      <>
                      <LessonListItem
                        key={index}
                        index={index}
                        pathname={lessonRecipe.pathname}
                        progressStatus={"completed"}
                        title={t(lessonRecipe.name)}
                        description={t(lessonRecipe.description)}
                        imgPath={lessonRecipe.imgPath}
                        instructor={lessonRecipe.instructor}
                        AnimalType={lessonRecipe.AnimalType}
                        instructorName={t(lessonRecipe.instructorName)}
                        state={getLessonState(index, lessonRecipe.lockedIfNotSubscribed)}
                        isCurrent={lessonsProgress === index}
                        lockedIfNotSubscribed={lessonRecipe.lockedIfNotSubscribed}
                        hasSeenPaywall={hasSeenPaywall}
                        badge={lessonRecipe.badge}
                        size={lessonRecipe.size}
                        stepsCount={lessonRecipe.steps.length}
                        openLessonTodoPopup={openLessonTodoPopup}
                        lessonRequirements={getLessonRequirementsArr(lessonRecipe.steps)}
                        teaserThumbnail={lessonRecipe.teaserThumbnail}
                        setIsPWallOpen={setIsPWallOpen}
                        activityNumber={lessonRecipe.activityNumber}
                        onOpenVideo={()=>{
                          setLessonVideoItemURL(lessonRecipe.teaserUrl)
                          onOpenVideo()
                          }
                        }
                      />
                      {index < LessonsRecipe.length - 1 && (
                          <div className="arrow-next-lesson">
                            <img src="/assets/icons/icon_arrow-forward.svg" alt="arrow" />
                          </div>
                        )}
                      </>
                    )}
                    {lessonRecipe.type === "SingleStepLesson" && (
                      <>
                        <LessonVideoItem 
                          key={index} 
                          coinName={lessonRecipe.coinName}
                          pathname={lessonRecipe.pathname}
                          setLessonVideoItemURL={setLessonVideoItemURL}
                          name={t(lessonRecipe.name)}
                          description={t(lessonRecipe.description)}
                          state={getLessonState(index, lessonRecipe.lockedIfNotSubscribed)}
                          onClick={onOpenVideo}
                          videoUrl={lessonRecipe.url}
                          CurrentSelectedStep={lessonsProgress === index}
                          isCurrent={lessonsProgress === index}
                          setIsPWallOpen={setIsPWallOpen}
                        />
                        {index < LessonsRecipe.length - 1 && (
                          <div className="arrow-next-lesson">
                            <img src="/assets/icons/icon_arrow-forward.svg" alt="arrow" />
                          </div>
                        )}
                      </>
                    )}

                  </React.Fragment>
                ))}


              </div>
          </div>
      </>
      }
    </>
  );
}

export default Lessons;
